import { Box, Card, CircularProgress, Typography } from "@mui/material";
import { FaExclamationTriangle } from "react-icons/fa";

import { BudgetDashboardSummary } from "../../../types/dashboard";

interface StaleProjectsCardProps {
  summary?: BudgetDashboardSummary;
  isLoading: boolean;
  active: boolean;
  onToggle: () => void;
}

export const StaleProjectsCard = ({
  summary,
  isLoading,
  active,
  onToggle,
}: StaleProjectsCardProps) => {
  const staleDays = summary?.staleDays ?? 7;
  const staleCount = summary?.staleCount ?? 0;
  const withoutBudget = summary?.withoutBudget ?? 0;

  const explanation = withoutBudget
    ? `${Math.round(
        (staleCount / withoutBudget) * 100
      )}% dos projetos sem orçamento (${staleCount} de ${withoutBudget})`
    : "Nenhum projeto sem orçamento no período";

  return (
    <Card
      onClick={onToggle}
      elevation={0}
      sx={{
        p: "16px 18px",
        mb: "20px",
        display: "flex",
        alignItems: "center",
        gap: "14px",
        cursor: "pointer",
        borderRadius: "12px",
        border: "1px solid #FED7AA",
        borderLeft: "4px solid #F97316",
        backgroundColor: active ? "#FFEDD5" : "#FFF7ED",
        boxShadow: active ? "inset 0 0 0 2px #F97316" : "none",
        transition: "background-color .15s ease, box-shadow .15s ease",
        "&:hover": {
          backgroundColor: "#FFEDD5",
          boxShadow: active
            ? "inset 0 0 0 2px #F97316"
            : "0 3px 10px rgba(249,115,22,.15)",
        },
      }}
    >
      <Box
        sx={{
          fontSize: 20,
          lineHeight: 1,
          color: "#EA580C",
          flexShrink: 0,
          display: "flex",
        }}
      >
        <FaExclamationTriangle />
      </Box>

      <Box
        flex={1}
        minWidth={0}
        display="flex"
        flexDirection="column"
        gap="3px"
      >
        <Typography fontSize={14} fontWeight={700} color="#9A3412">
          Projetos sem orçamento há mais de {staleDays} dias
        </Typography>
        <Typography fontSize={13} fontWeight={600} color="#C2410C">
          {isLoading ? "Calculando..." : explanation}
        </Typography>
        <Typography fontSize={11.5} color="#D98A5A">
          {active
            ? "Filtro ativo · clique para remover"
            : "Clique para filtrar a lista abaixo"}
        </Typography>
      </Box>

      <Box
        flexShrink={0}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Typography
          fontSize={30}
          fontWeight={800}
          lineHeight={1}
          color="#EA580C"
          sx={{ fontVariantNumeric: "tabular-nums" }}
        >
          {isLoading ? <CircularProgress size={22} /> : staleCount}
        </Typography>
        <Typography fontSize={11} fontWeight={600} color="#C2410C" mt="3px">
          projetos
        </Typography>
      </Box>
    </Card>
  );
};
